/* eslint-disable no-undef */

import React, {Component} from 'react'
import Base from '../BaseComponent'
import CustomMarker from '../CustomMarker'
import CustomOverlay from '../CustomOverlay'
import {TweenLite, Expo} from 'gsap';

import { compose, withProps, lifecycle } from "recompose"
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps"

//import withData from '../../utils/withData';

// global map styles
const mapStyles = require("../../utils/mapStyles.json");

let mapMounted = false
let mapRef = false

const MyMapComponent = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDDLRWpVufzuhIhNq9NS_0r0BSHfbZ8oIU&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '100%' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  lifecycle({


    componentWillReceiveProps(nextProps)
    {
      //console.log('map componentWillReceiveProps')
      let isTouch = "ontouchstart" in document.documentElement ? true : false
      if(mapMounted)
      {
        //console.log('fitbounds',nextProps.fitBounds)
        this.setState({
            centre: nextProps.activeCenter ? nextProps.activeCenter :nextProps.centre,
            markers: nextProps.markers,
            zoom: nextProps.activeCenter ? 18 : 16
          });


        if(!isTouch) {
        const mapBounds = nextProps.mapBounds

        const bounds = new google.maps.LatLngBounds();

          mapBounds.map(marker => {
            if(marker.latitude != '') {
              const ll = new window.google.maps.LatLng(marker.longitude, marker.latitude);
              bounds.extend(ll)
            }
          });

          mapRef.fitBounds(bounds);
        }

        
      }
    },
    componentWillUnmount(){
        mapMounted = false;
    },

    componentDidMount() {
      const refs = {}
      const markers = this.props.markers
      const centre = this.props.activeCenter ? this.props.activeCenter : this.props.centre
      const filter = this.props.markerFilter
      const mapBounds = this.props.mapBounds
      const zoom = this.props.activeCenter ? 18 : 16

      let isTouch = "ontouchstart" in document.documentElement ? true : false
      //const set


      this.setState({
        bounds: null,
        center: centre,
        markers: markers,
        zoom: zoom,
        isMounted: false,
        onMapMounted: ref => {
          if(mapBounds.length) {
          if(!ref) return;
          refs.map = ref;
          mapRef = ref

          if(!isTouch) {

          const bounds = new google.maps.LatLngBounds();


          mapBounds.map(marker => {
            if(marker.latitude != '') {
              const ll = new window.google.maps.LatLng(marker.longitude, marker.latitude);
              bounds.extend(ll)
            }
          });

          refs.map.fitBounds(bounds);
          //console.log('fit bounds')
        }
          mapMounted = true;
          mapRef = ref;

        }
        }
        
      })
    },
  }),
  withGoogleMap
)(props =>
  <GoogleMap
    ref={props.onMapMounted}
    activeCenter={props.activeCenter}
    zoom={props.zoom}
    center={props.centre}
    defaultOptions={{ styles: mapStyles, disableDefaultUI: true}}>
    {props.markers}
    {props.overlay}
  </GoogleMap>
);

class Map extends Component {
  state = {
    centre: {lat: 42.344176, lng: -71.098547}
  }

  icon = {
        path: "M0,15.93H3.93L1.17,0,6,4.43,10.8,0,8.13,15.93H12l-6,8.4Z",
        fillColor: '#000000',
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 1
    }
    // for mouseovers
    iconYellow = {
          path: "M0,15.93H3.93L1.17,0,6,4.43,10.8,0,8.13,15.93H12l-6,8.4Z",
          fillColor: '#FFC03B',
          fillOpacity: 1,
          strokeWeight: 0,
          scale: 1
      }

  

  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      mapRef: false,
      centre: {lat: 42.344176, lng: -71.098547},
      setBounds: true,
      icon: this.icon,
      overlayPosition: {lat: 42.344176, lng: -71.098547},
      overlayTitle: 'Empty',
      icon: this.icon,
      overlayOpacity: 0,
      overlayTop: '50px',
      hasActiveMarker: false
    };
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps)
  {
    /*if(nextProps.activeMarker && !this.state.hasActiveMarker)
        {
          this.setOverlay({},nextProps.activeMarker)
          this.setState({hasActiveMarker : true})
        } else if(nextProps.activeMarker == null) {
          this.hideOverlay();
          this.setState({hasActiveMarker : false})
        }*/
  }



  setOverlay = (evt, marker) => {

    let _this = this;


    this.setState({
      overlayPosition: {lat: parseFloat(marker.longitude), lng: parseFloat(marker.latitude) },
      overlayTitle: marker.title,
      overlayImage: marker.image[0]
    })

    let val = {opacity:0,top:15}

    let t = TweenLite.to(val,.5,{opacity:1,top:0,ease: Expo.easeOut,onUpdate: function(){

        _this.setState({
          overlayOpacity: val.opacity,
          overlayTop: val.top + 'px'
        });

      }})

  }

  hideOverlay = () => {

    //console.log('hideOverlay')

    let _this = this;
    let val = {opacity:1, top: 0}

    let t = TweenLite.to(val,.5,{opacity:0,top: 15,ease: Expo.easeOut,onUpdate: function(){

        _this.setState({
          overlayOpacity: val.opacity,
          overlayTop: val.top + 'px'
        });

      }})
  }

  

  setCenter = (e,marker) => {
    //console.log(e,marker.latitude, marker.longitude)

    this.setState({
      centre: {lat: parseFloat(marker.longitude), lng: parseFloat(marker.latitude) },
      setBounds: false
    })
  }

  

  

  render() {

      //console.log('Map.jsx render')

    	//position object from props
    	const latlng = {lat: 42.344176, lng: -71.098547}
    	const markerData = this.props.markers
      let bounds = []; // contains all entries for map bounds
      let activeMarkers = []; // contains filtered entries
      const filter = this.props.filter

      // work out which to include as markers
      for(var i =0; i<markerData.length;i++)
      {
        if(markerData[i].locationCategory == filter || filter === null) activeMarkers.push(markerData[i]); // null is for 'all'
        bounds.push(markerData[i]);
      }

    	let markers = activeMarkers.map( (marker, index) => 
        <CustomMarker
                  data={marker}
                  markerOver={this.setOverlay}
                  markerOut={this.hideOverlay}
                  markerKey={index}
                  key={index}
                  isActive={(this.props.activeMarker && this.props.activeMarker.id == marker.id) ? true : false}
                  position={{ lat: parseFloat(marker.longitude), lng: parseFloat(marker.latitude) }}
                />)

      let overlay = <CustomOverlay
                        title={this.state.overlayTitle}
                        image={this.state.overlayImage}
                        data={this.state.data}
                        position={this.state.overlayPosition}
                        opacity={this.state.overlayOpacity}
                        top={this.state.overlayTop}
              />

      

        return (
          <MyMapComponent
            centre={this.state.centre}
            activeCenter={this.props.activeCenter}
            markers={markers}
            mapBounds={bounds}
            overlay={overlay}
            fitBounds={this.props.fitBounds}
          />
        )
      }
}

export default Map



// WEBPACK FOOTER //
// ./src/js/components/Map/Map.jsx